export const routes = [
  {
    path: '/indicador',
    component: () => import(/* webpackChunkName: "ur" */ './components/List'),
    name: 'indicador.list'
  }
]
